var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{attrs:{"placement":_vm.placement}},[_c('button',{staticClass:"tooltip-target b3",attrs:{"type":"button"}},[_vm._t("icon")],2),_c('template',{slot:"popover"},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }